(function () {
  'use strict';
  if (window.TealibereReviewData) return;

  var configElement = document.getElementById('tl-reviews-config');
  if (!configElement) return;
  var config;
  try { config = JSON.parse(configElement.textContent); } catch (error) { return; }
  if (!config.indexUrl) return;
  var indexUrl = new URL(config.indexUrl, document.baseURI).href;
  var requests = new Map();
  var productCache = window.TL_REVIEWS = window.TL_REVIEWS || {};
  var indexCache = null;
  var catalogCache = null;

  function readJSON(url) {
    if (requests.has(url)) return requests.get(url);
    var request = fetch(url, { credentials: 'omit' }).then(function (response) {
      if (!response.ok) throw new Error('Review data request failed: ' + response.status);
      return response.json();
    }).catch(function (error) {
      requests.delete(url);
      throw error;
    });
    requests.set(url, request);
    return request;
  }

  function assetURL(filename) {
    if (!/^tealibere-reviews-[a-z0-9-]+\.json$/.test(filename)) throw new Error('Invalid review asset filename');
    return new URL(filename, indexUrl).href;
  }

  function loadIndex() {
    if (indexCache) return Promise.resolve(indexCache);
    return readJSON(indexUrl).then(function (index) {
      if (index.schemaVersion !== 1 || !index.products) throw new Error('Unsupported review index');
      indexCache = index;
      return index;
    });
  }

  function loadProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return loadIndex().then(function (index) {
      if (!Object.prototype.hasOwnProperty.call(index.products, handle)) return null;
      return readJSON(assetURL(index.products[handle].asset)).then(function (data) {
        if (!data || !Array.isArray(data.reviews)) throw new Error('Invalid product review data');
        productCache[handle] = data;
        return data;
      });
    });
  }

  function loadCatalog() {
    if (catalogCache) return Promise.resolve(catalogCache);
    return loadIndex().then(function (index) { return readJSON(assetURL(index.catalog)); }).then(function (catalog) {
      if (catalog.schemaVersion !== 1 || !Array.isArray(catalog.entries) || !Array.isArray(catalog.handles)) throw new Error('Invalid review catalog');
      catalogCache = catalog;
      return catalog;
    });
  }

  function sortedEntries(entries, sort, filterStar) {
    var filtered = filterStar > 0 ? entries.filter(function (entry) { return entry[3] === filterStar; }) : entries.slice();
    filtered.sort(function (a, b) {
      if (sort === 'highest' && a[3] !== b[3]) return b[3] - a[3];
      if (sort === 'lowest' && a[3] !== b[3]) return a[3] - b[3];
      return b[2].localeCompare(a[2]);
    });
    return filtered;
  }

  function getPage(options) {
    var settings = Object.assign({ handle: null, sort: 'newest', filterStar: 0, page: 1, perPage: 10 }, options);
    var perPage = Math.max(1, Math.min(50, Math.floor(Number(settings.perPage)) || 10));
    var source = settings.handle ? loadProduct(settings.handle).then(function (data) {
      return { handles: [settings.handle], entries: data ? data.reviews.map(function (review, i) { return [0, i, review.date, review.rating]; }) : [] };
    }) : loadCatalog();
    return source.then(function (catalog) {
      var filtered = sortedEntries(catalog.entries, settings.sort, Number(settings.filterStar));
      var totalPages = Math.ceil(filtered.length / perPage);
      var page = Math.min(Math.max(1, Math.floor(Number(settings.page)) || 1), totalPages || 1);
      var selected = filtered.slice((page - 1) * perPage, page * perPage);
      var needed = Array.from(new Set(selected.map(function (entry) { return catalog.handles[entry[0]]; })));
      return Promise.all(needed.map(loadProduct)).then(function () {
        return {
          page: page, totalPages: totalPages, total: filtered.length,
          reviews: selected.map(function (entry) {
            var handle = catalog.handles[entry[0]];
            var review = productCache[handle].reviews[entry[1]];
            if (!review) throw new Error('Review catalog does not match product shard');
            return Object.assign({}, review, { _handle: handle });
          })
        };
      });
    });
  }

  window.TealibereReviewData = {
    loadIndex: loadIndex,
    loadProduct: loadProduct,
    getPage: getPage,
    getSummary: function (handle) { return indexCache && indexCache.products[handle] || null; },
    getProduct: function (handle) { return productCache[handle] || null; }
  };
})();
